import React from 'react';
import { Button, Text } from '@ui';
/**
 * Zero-attachments empty state (E2E-04). Deliberately the opposite of the
 * `DeficienciesStep` convention: the section-header CTA is hidden by the
 * caller and this block carries its own CTA instead.
 */
export function AttachmentsEmptyState({ title, description, ctaLabel, onAdd }) {
    return (React.createElement("div", { className: "attachments-surface__empty", "data-testid": "attachments-empty-state" },
        React.createElement("i", { className: "fa-light fa-paperclip attachments-surface__empty-icon", "aria-hidden": "true" }),
        React.createElement(Text, { variant: "medium", as: "h3", className: "attachments-surface__empty-title" }, title),
        React.createElement(Text, { variant: "body", className: "attachments-surface__empty-description" }, description),
        onAdd && ctaLabel ? (React.createElement(Button, { variant: "default", onClick: onAdd, className: "attachments-surface__empty-cta" },
            React.createElement("i", { className: "fa-light fa-plus", "aria-hidden": "true" }),
            " ",
            ctaLabel)) : null));
}
